import React, { FC } from 'react';
import { TimePicker as AntdTimePicker } from 'antd';
import { TimePickerProps } from 'antd/lib/time-picker';

export const TimePicker: FC<TimePickerProps> = (props) => {
  return <AntdTimePicker {...props} />;
};

export default TimePicker;
